import pluralize from 'pluralize';

const pluralizeCells = (countCells) => `${countCells} ${pluralize('cell', countCells)}`;
const pluralizeRows = (countRows) => `${countRows} ${pluralize('row', countRows)}`;

export { pluralizeCells, pluralizeRows };
